export const visitorID = (state) => state.profileData.visitorID;
export const profileData = (state) => state.profileData.visitorProfile;